import React, { Component } from 'react';
import { getError } from 'helpers/errors';

class UserSimoCycleTypeToggle extends Component {
  state = {
    error: '',
  };

  toggle = async (event) => {
    const { userId, cycle_type, onToggle } = this.props;
    try {
      await onToggle(
        userId,
        cycle_type === 'calendar' ? 'activation' : 'calendar',
      );
      this.setState({
        error: '',
      });
    } catch (err) {
      const error = getError(err);
      this.setState({ error });
    }
  };

  render() {
    const { error } = this.state;

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.toggle}>
          Toggle simo cycle type
        </button>
        {error && (
          <React.Fragment>
            <br />
            <span className="text-danger">{error}</span>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default UserSimoCycleTypeToggle;
